import React, { useState, useEffect } from 'react';
import BaseLayout from './layout/BaseLayout';
import { useRoutes } from 'react-router-dom';
import HomePage from './pages/Home';
import LicenceMaster from './pages/Licencemaster';
import FeedModules from './pages/Feedmodules';
import ModuleMaster from './pages/Modulemaster';
import Login from './pages/Login';
import ChangePassword from './pages/UserProfile/changePassword';
import Versionmaster from './pages/Versionmaster';
import PrivacyPolicy from './pages/Privacypolicy';
import ManageLogin from './pages/ManageLogin';
import PackageMaster from './pages/PackageMaster';
import Subscriptions from './pages/Subscriptions';
import VendorMaster from './pages/VendorMaster';
import DomainCertificate from './pages/Domaincertificate';
import ServiceWatch from './pages/ServiceWatch';
import ConnectionEncryptDecrypt from './pages/ConnectionEncryptDecrypt';
import VersionNumbers from './pages/VersionNumbers';
import VersionContains from './pages/VersionContains';
import BulkVersionUpload from './pages/VersionContains/BulkVersionUpload';

export default function Router(props: any) {

  let userAuthData: any = sessionStorage.getItem("userAuthData");
  userAuthData = JSON.parse(userAuthData);

  // const checkAccess = (name: string) => {
  //   if (userAuthData?.role === "AdminOfficeUser" || userAuthData?.role === "DealerOfficeUser") {
  //     if (!!props?.userAccess && !!props?.userAccess[name]) {
  //       if (props?.userAccess[name]?.moduleAdd === false && props?.userAccess[name]?.moduleDelete === false && props?.userAccess[name]?.moduleEdit === false && props?.userAccess[name]?.moduleView === false) {
  //         return "RoleNoAccess";
  //       }
  //       else {
  //         return "RoleAccess";
  //       }
  //     }
  //   } else {
  //     return "AllAccess";
  //   }
  // }

  return useRoutes([
    {
      path: '/',
      element: <BaseLayout />,
      children: [
        { path: '/', element: <Login /> },
        { path: '/home', element: <HomePage />},
        { path: '/licencemaster', element: <LicenceMaster />},
        { path: '/feedmodules', element: <FeedModules />},
        { path: '/modulemaster', element: <ModuleMaster />},
        { path: '/changepassword', element: <ChangePassword /> },
        { path: '/versionmaster', element: <Versionmaster /> },
        { path: '/privacypolicy', element: <PrivacyPolicy/>},
        { path: '/managelogin', element: <ManageLogin/>},
        { path: '/packagemaster', element: <PackageMaster/>},
        { path: '/subscription', element: <Subscriptions/>},
        { path: '/vendormaster', element: <VendorMaster/>},
        { path: '/domaincertificate', element: <DomainCertificate/>},
        { path: '/servicewatch', element: <ServiceWatch/>},
        { path: '/servicewatch/:id', element: <ServiceWatch/>},
        { path: '/connectionencryptdecrypt', element: <ConnectionEncryptDecrypt/>},
        { path: '/versionnumbering', element: <VersionNumbers/>},
        { path: '/versioncontains', element: <VersionContains/>},
        { path: '/bulkupload', element: <BulkVersionUpload/>},
        // { path: '/home', element: (checkAccess("Home") === "RoleAccess" || checkAccess("Home") === "AllAccess") ? <HomePage /> : <NoRights pageName={"Home"} /> }
      ],
    },
    // { path: '/symbols', element: <Symbols /> },
    // { path: '/nse', element: <MasterSymbol /> },
    // { path: '/bse', element: <MasterSymbol /> },
    // {
    //   path: '/eodRollOut',
    //   element: <EodRollOver />,
    //   children: [{path: '', element: <HomePage/>}],
    // }
  ])
}
